<template>
  <header>
    <nav class="navbar">
      <div class="container d-flex">
        <a>
          <img :src="logoFrontLeft" class="img-fluid" alt="Logo Left" />
        </a>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  computed: {
    logoFrontLeft() {
      return this.$store.getters['ui/dataUI']('headerLogos.logoFrontLeft');
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  @include themify($themes) {
    background-color: themed('appHeaderBackgroundColor');
  }
  background-color: $color-gray-light;
  padding: 10px 0;

  .navbar {
    .container {
      @media #{$mobile-device} {
        padding-right: 0;
        padding-left: 0;
      }
    }

    div {
      min-width: 325px;

      img {
        max-height: 40px;

        @media #{$mobile-device} {
          max-width: 170px;
        }
      }
    }
  }
}
</style>
